<div>
    <!-- Nav Bar -->
    <app-navbar></app-navbar>

    <!-- Routed views go here -->
    <div class="main-view">
        <router-outlet></router-outlet>
    </div>

    <!-- Footer -->
    <app-footer></app-footer>

    <!-- Consent -->
    <app-consent></app-consent>
</div>

<!-- Loader -->
<div id="loader" class="loader-main"></div>